import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"painel-info",style:({
    backgroundColor: _vm.backgroundColor,
    borderColor: _vm.borderColor
  })},[_c(VIcon,{attrs:{"color":_vm.iconColor,"size":"24"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"painel-info-text",style:({ color: _vm.textColor })},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }